<template>
  <div id="tabs">

    <div class="container bg-primary" v-if="bypasses" style="text-align:center;">

      <h3 style="color: white;">Tarifas</h3>

      <ul>
        <li v-for="bypass in bypasses" :key="bypass.id" :class="{ active: activeTab === bypass.id }"
          @click="bypassSelected(bypass.id)">
          {{ bypass.name }}
        </li>
      </ul>
      <div v-if="activeTab > 0">
        <div class="tab-content text-center">
          <div class="table-responsive">
            <table class="table align-items-center mb-0 containers">
              <thead>
                <tr>
                  <th>Clase</th>
                  <th>Descripción</th>
                  <th>Tarifa</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rate in rates" :key="rate.id">
                  <td>{{ rate.kind }}</td>
                  <td>{{ rate.description }}</td>
                  <td>{{ `MXN $${Number.parseFloat(rate.price).toFixed(2)}` }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row justify-content-center">
            <div class="text-end message mt-3" style="color: white; font-size: .8em;">
              <small>*LOS PRECIOS Y TARIFAS ESTÁN SUJETOS A CAMBIOS SIN PREVIO AVISO</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {

  name: "TabsSection",


  data() {
    return {
      bypasses: undefined,
      activeTab: 0,
      rates: undefined,
    };
  },

  methods: {
    bypassSelected(bypassID) {
      this.activeTab = bypassID
      this.plain
        .get(`/rates`, { params: { bypassID } })
        .then((response) => {
          if (response.data.length !== 0) this.rates = response.data;
          else this.rates = [];
        })
        .catch((err) => {
          this.rates = [];
          console.log(err);
        });
    }
  },

  created() {
    this.plain
      .get(`/bypasses`)
      .then((response) => {
        if (response.data.length !== 0) {
          this.bypasses = response.data;
          this.bypassSelected(this.bypasses[0].id);
        }
        else this.bypasses = [];
      })
      .catch((err) => {
        this.bypasses = [];
        console.log(err);
      });
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: auto;
  margin: auto;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 30px;
}

table {
  width: 80%;
  margin: 0 auto;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  justify-content: space-around;
  align-items: center;
  border-bottom: 2px solid rgba(2999, 299, 2999);
  position: relative;
  font-size: 1.3em;
  font-weight: 600;
  background: none;
  border: none;
  padding: 7px;
  cursor: pointer;
  color: rgba(217, 217, 217, 0.515);
  margin: 0 auto;
}

li.active {
  font-weight: bold;
  color: #ffffff;
}

.tab-content {
  padding: 10px;
}

th {
  color: white;
}

td {
  color: white;
}

.containers {
  animation: moving .5s ease;
}

@keyframes moving {
  from {
    transform: translateX(50px);
    opacity: 0;
  }

  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@media screen and (max-width: 415px) {
  .container {
    width: 95%;
  }

  li {
    font-size: .7em;
  }

  table {
    width: auto;
    margin: 0 auto;
  }

  th {
    font-size: .7em;
  }

  td {
    font-size: .7em;
  }
}
</style> 



